import { metadataConstants } from "../actions/actionTypes";

export const metadata = (state = {}, action) => {
  if (action != null) {
    switch (action.type) {
      case metadataConstants.METADATA_REQUEST:
        return state;
      case metadataConstants.METADATA_FAILURE:
        return {
          ...state,
        };
      case metadataConstants.METADATA_SUCCESS:
        return {
          ...state,
          data: action.metadata,
          links: {
            cookiePolicy: action.metadata.links.cookiePolicy.href,
            helpCentre: action.metadata.links.helpCentre.href,
            privacyPolicy: action.metadata.links.privacyPolicy.href,
            termsAndConditions: action.metadata.links.termsAndConditions.href,
          },
        };
      default:
        return state;
    }
  }
};
